import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'delete-cash-report-item-dialog',
    templateUrl: './deleteCashReportItemDialog.component.html',
    styleUrls: ['./deleteCashReportItemDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DeleteCashReportItemDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<DeleteCashReportItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private _formBuilder: FormBuilder,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.form = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            reason: ['', Validators.required],
        });
    }
}
